export const beagleJorney = [
  {
    id: 1,
    waypoint: {
      name: "waypoint1",
      seqId: 2,
      cord: [850, 381],
      descriptionCord: [752, 320],
      description: `Plymouth
27 de diciembre 
1831`,
    },
    postal: {
      name: "postal1",
      desktop: [100, 100],
      mobile: [100, 100],
    },
  },
  {
    id: 2,
    waypoint: {
      name: "waypoint2",
      seqId: 5,
      cord: [792, 518],
      descriptionCord: [680, 458],
      description: `Las islas Canarias
Enero
1832`,
    },
    postal: {
      name: "postal2",
      desktop: [100, 100],
      mobile: [100, 100],
    },
  },
  {
    id: 3,
    waypoint: {
      name: "waypoint3",
      seqId: 8,
      cord: [763, 600],
      descriptionCord: [646, 541],
      description: `Islas de Cabo Verde
Enero
1832`,
    },
    postal: {
      name: "postal3",
      desktop: [100, 100],
      mobile: [100, 100],
    },
  },
  {
    id: 4,
    waypoint: {
      name: "waypoint4",
      seqId: 11,
      cord: [675, 740],
      descriptionCord: [590, 680],
      description: `San Salvador
Febrero
1832`,
    },
    postal: {
      name: "postal4",
      desktop: [100, 100],
      mobile: [100, 100],
    },
  },
  {
    id: 5,
    waypoint: {
      name: "waypoint5",
      seqId: 14,
      cord: [660, 792],
      descriptionCord: [570, 733],
      description: `Río de Janeiro
Abril
1832`,
    },
    postal: {
      name: "postal5",
      desktop: [100, 100],
      mobile: [100, 100],
    },
  },
  {
    id: 6,
    waypoint: {
      name: "waypoint6",
      seqId: 17,
      cord: [595, 870],
      descriptionCord: [512, 810],
      description: `Punta Alta
Julio
1832 - 1833`,
    },
    postal: {
      name: "postal6",
      desktop: [100, 100],
      mobile: [100, 100],
    },
  },
  {
    id: 7,
    waypoint: {
      name: "waypoint7",
      seqId: 20,
      cord: [556, 910],
      descriptionCord: [469, 862],
      description: `Bahía Blanca
1833`,
    },
    postal: {
      name: "postal7",
      desktop: [100, 100],
      mobile: [100, 100],
    },
  },
  {
    id: 8,
    waypoint: {
      name: "waypoint8",
      seqId: 23,
      cord: [589, 979],
      descriptionCord: [500, 932],
      /* descriptionCord: [460, 955], */
      description: `Islas Malvinas
1833`,
    },
    postal: {
      name: "postal8",
      desktop: [100, 100],
      mobile: [100, 100],
    },
  },
  {
    id: 9,
    waypoint: {
      name: "waypoint9",
      seqId: 26,
      cord: [546, 1010],
      descriptionCord: [451, 952],
      description: `Tierra de fuego
Julio
1832 - 1834`,
    },
    postal: {
      name: "postal9",
      desktop: [100, 100],
      mobile: [100, 100],
    },
  },
  {
    id: 10,
    waypoint: {
      name: "waypoint10",
      seqId: 29,
      cord: [498, 917],
      descriptionCord: [414, 857],
      description: `Chiloé
Enero
1835`,
    },
    postal: {
      name: "postal10",
      desktop: [100, 100],
      mobile: [100, 100],
    },
  },
  {
    id: 11,
    waypoint: {
      name: "waypoint11",
      seqId: 32,
      cord: [505, 882],
      descriptionCord: [423, 822],
      description: `Valdivia
Febrero
1835`,
    },
    postal: {
      name: "postal11",
      desktop: [100, 100],
      mobile: [100, 100],
    },
  },
  {
    id: 12,
    waypoint: {
      name: "waypoint12",
      seqId: 35,
      cord: [434, 690],
      descriptionCord: [311, 630],
      description: `Galápagos
Septiembre a octubre
1835`,
    },
    postal: {
      name: "postal12",
      desktop: [100, 100],
      mobile: [100, 100],
    },
  },
  {
    id: 13,
    waypoint: {
      name: "waypoint13",
      seqId: 38,
      cord: [1762, 865],
      descriptionCord: [1660, 805],
      description: `La bahía de islas
Diciembre
1835`,
    },
    postal: {
      name: "postal13",
      desktop: [100, 100],
      mobile: [100, 100],
    },
  },
  {
    id: 14,
    waypoint: {
      name: "waypoint14",
      seqId: 41,
      cord: [1650, 860],
      descriptionCord: [1565, 802],
      description: `Sydney
Enero
1836`,
    },
    postal: {
      name: "postal14",
      desktop: [100, 100],
      mobile: [100, 100],
    },
  },
  {
    id: 15,
    waypoint: {
      name: "waypoint15",
      seqId: 44,
      cord: [1365, 746],
      descriptionCord: [1282, 685],
      description: `Islas Cocos
Abril
1836`,
    },
    postal: {
      name: "postal15",
      desktop: [100, 100],
      mobile: [100, 100],
    },
  },
  {
    id: 16,
    waypoint: {
      name: "waypoint16",
      seqId: 47,
      cord: [968, 867],
      descriptionCord: [811, 805],
      description: `Cabo de la Buena Esperanza
Mayo a junio
1836`,
    },
    postal: {
      name: "postal16",
      desktop: [100, 100],
      mobile: [100, 100],
    },
  },
  {
    id: 17,
    waypoint: {
      name: "waypoint17",
      seqId: 50,
      cord: [692, 751],
      descriptionCord: [608, 690],
      description: `Bahía
Agosto
1836`,
    },
    postal: {
      name: "postal17",
      desktop: [100, 100],
      mobile: [100, 100],
    },
  },
  {
    id: 18,
    waypoint: {
      name: "waypoint18",
      seqId: 53,
      cord: [863, 395],
      descriptionCord: [780, 335],
      description: `Plymouth
2 de octubre
1836`,
    },
    postal: {
      name: "postal18",
      desktop: [100, 100],
      mobile: [100, 100],
    },
  },
];

export const getResolution = () => {
  return {
    width: 1920,
    height: 1080,
  };
};
